import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { TranslateService } from '@ngx-translate/core';
import { OrganizationInterface, ReviewInterface } from '@sport-activities/sdk';
import { Subscription } from 'rxjs';

import { TabBarLinkInterface } from '~/component/router-tab-bar/interfaces/tab-link.interface';
import { organizerStatus } from '~/organizer/enums/organizer-status.enum';
import { CustomHeadTagService } from '~/core/services/custom-head-tag/custom-head-tag.service';

@Component({
  selector: 'app-attendee-organizer-page',
  templateUrl: './organizer-page.component.html',
  styleUrls: ['./organizer-page.component.scss'],
})
export class AttendeeOrganizerPageComponent implements OnInit, OnDestroy {
  private readonly subscriptions = new Subscription();
  public readonly tabBarlinks: TabBarLinkInterface[] = [];
  public organization: OrganizationInterface;
  public reviews: ReviewInterface[];
  constructor(
    private readonly translateService: TranslateService,
    private readonly localizeRouterService: LocalizeRouterService,
    private readonly activatedRoute: ActivatedRoute,
    private readonly customHeadTagService: CustomHeadTagService
  ) {}

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public ngOnInit(): void {
    this.subscriptions.add(
      this.activatedRoute.data.subscribe(({ data }) => {
        this.organization = data;
        this.setContentMeta();
      })
    );

    this.tabBarlinks.push(
      ...['activities', 'reviews'].map((status) => ({
        name: this.translateService.instant(`organizer.tab_bar.link.${status}`),
        path: this.localizeRouterService
          .translateRoute(`attendee.${status}`)
          .toString(),
      }))
    );
  }

  public setContentMeta(): void {
    if (this.organization?.status === organizerStatus.DISABLED) {
      this.customHeadTagService.addTag('meta', {
        name: 'robots',
        content: 'noindex, nofollow',
        id: 'content-meta',
      });
    }
  }
}
